import Vue from "vue";
import App from "@/App.vue";
import vuetify from "@/plugins/vuetify";
import { createProvider } from "@/vue-apollo";
import VueRouter from "vue-router";
import { router } from "@/router/index.js";
import store from "@/store/index.js";
import TextHighlight from 'vue-text-highlight';
 
Vue.component('text-highlight', TextHighlight);
Vue.config.productionTip = false;
Vue.use(VueRouter);

new Vue({
  store,
  router,
  vuetify,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount("#app");
